import { ReactNode } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@hiring-intelligence/ui';

export interface DetailTabDef {
	value: string;
	label: string;
	content: ReactNode;
}

/**
 * Center-pane tab bar — "Overview / Activities / Intelligence" — styled to
 * match HubSpot's pill-style underline tabs over a white card surface.
 */
export function DetailTabs({
	value,
	onValueChange,
	tabs,
	rightAction
}: {
	value: string;
	onValueChange: (v: string) => void;
	tabs: DetailTabDef[];
	rightAction?: ReactNode;
}) {
	return (
		<Tabs value={value} onValueChange={onValueChange} className="w-full">
			<div className="flex items-center justify-between border-b bg-card rounded-t-lg px-2">
				<TabsList className="h-11 bg-transparent p-0 gap-0">
					{tabs.map((t) => (
						<TabsTrigger
							key={t.value}
							value={t.value}
							className="h-11 rounded-none border-b-2 border-transparent px-4 text-sm font-medium text-muted-foreground data-[state=active]:border-primary data-[state=active]:text-foreground data-[state=active]:shadow-none data-[state=active]:bg-transparent"
						>
							{t.label}
						</TabsTrigger>
					))}
				</TabsList>
				{rightAction && <div className="pr-2">{rightAction}</div>}
			</div>
			{tabs.map((t) => (
				<TabsContent key={t.value} value={t.value} className="mt-4 space-y-4 focus-visible:outline-none">
					{t.content}
				</TabsContent>
			))}
		</Tabs>
	);
}
